/**
 * Theme factory from THEME-DESIGN.md.
 * getTheme('light' | 'dark') returns MUI theme for App.
 */

import { createTheme } from '@mui/material/styles';
import { getPalette } from './palette';
import { typography } from './typography';
import { getComponents } from './components';

const shape = {
  borderRadius: 8,
};

export function getTheme(mode) {
  const palette = getPalette(mode);
  const base = createTheme({
    palette,
    typography,
    shape,
  });
  return createTheme(base, {
    components: getComponents(base),
  });
}

export { getPalette } from './palette';
export { typography } from './typography';
export { getComponents } from './components';
